import { render, staticRenderFns } from "./DeleteDraftDialog.vue?vue&type=template&id=b04827be&"
import script from "./DeleteDraftDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteDraftDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports